class ToggleAppBarEvent extends CustomEvent {
  constructor() {
    super(ToggleAppBarEvent.EVENT);
  }

  static emit() {
    return document.dispatchEvent(new ToggleAppBarEvent());
  }

  static on(handler) {
    return document.addEventListener(ToggleAppBarEvent.EVENT, handler);
  }

  static off(handler) {
    return document.removeEventListener(ToggleAppBarEvent.EVENT, handler);
  }
}

ToggleAppBarEvent.EVENT = 'app:app-bar';

export default ToggleAppBarEvent;
